import React, { useEffect } from 'react';

/**
 * Simple inline toast component.
 * Props: message (string), type ('success'|'danger'|'warning'), onClose (fn), duration (ms, default 3500)
 */
export default function Toast({ message, type = 'success', onClose, duration = 3500 }) {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(onClose, duration);
    return () => clearTimeout(t);
  }, [message, duration, onClose]);

  if (!message) return null;

  const colors = {
    success: { bg: '#d4edda', border: '#c3e6cb', color: '#155724' },
    danger:  { bg: '#f8d7da', border: '#f5c6cb', color: '#721c24' },
    warning: { bg: '#fff3cd', border: '#ffeeba', color: '#856404' },
  };
  const style = colors[type] || colors.success;

  return (
    <div
      style={{
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 9999,
        padding: '12px 20px',
        borderRadius: 6,
        border: `1px solid ${style.border}`,
        backgroundColor: style.bg,
        color: style.color,
        fontSize: 14,
        fontWeight: 500,
        maxWidth: 360,
        boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
      }}
      role="alert"
    >
      <span style={{ flex: 1 }}>{message}</span>
      <button
        onClick={onClose}
        style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, lineHeight: 1, color: style.color, padding: 0 }}
      >
        ×
      </button>
    </div>
  );
}
